import React from 'react'
import PropTypes from 'prop-types'

import { Header, Icon } from 'semantic-ui-react'

import * as styles from './styles'

const ErrorMassive = ({ enabled, message }) =>
  enabled ? (
    <div style={styles.error}>
      <Icon name="info" size="massive" />

      <Header as="h1" content={message} />
    </div>
  ) : null

ErrorMassive.propTypes = {
  enabled: PropTypes.bool.isRequired,
  message: PropTypes.string,
}

ErrorMassive.defaultProps = {
  message: 'Something went wrong.',
}

export default ErrorMassive
